import React from 'react';
import PropTypes from 'prop-types';

import './TagGroup.scss';

export const TagGroup = (props) => {
    return (
        <section className={`tag-group ${props?.containerClassName || ''}`}>
            <div className="eds-l-pad-left-2 eds-l-pad-bot-8">
                <h3 className="eds-text-hs eds-text-color--grey-700">
                    {props.headerText}
                </h3>
            </div>
            <section className="tag-group__tags">
                {props.suggestedItems.map((tag) => props.render(tag))}
            </section>
        </section>
    );
};

TagGroup.propTypes = {
    suggestedItems: PropTypes.array.isRequired,
    headerText: PropTypes.string.isRequired,
    render: PropTypes.func.isRequired,
};
